<div class="container">
    <div class="row">
        <div class="col">
            <h4 >Endorse Certificate</h4>
        </div>
        <div class="col">
        </div>
        <div class="col">
        </div>
        <div class="col">
            <div class="row">
            <h4 style= "position: relative;">Balance: &nbsp; </h4>
            <h4 style= "position: relative; background-color:blanchedalmond;" >{{dealer.dealerBalance}}</h4>
        </div>
        </div>
    </div>
</div>
<br>

<!-- Endorsement Blocked Alert (More than 30 days from issue date) -->
<div *ngIf="endorsementBlocked" class="alert alert-danger" role="alert">
    <h5 class="alert-heading"><i class="fa fa-exclamation-triangle"></i> Endorsement Not Allowed</h5>
    <p>{{endorsementBlockedMessage}}</p>
    <hr>
    <p class="mb-0">
        <strong>Email:</strong> <a href="mailto:support&#64;allianceassure.in">support&#64;allianceassure.in</a>
    </p>
</div>

<!-- Days Since Issue Info -->
<div *ngIf="daysSinceIssue > 0 && !endorsementBlocked" class="alert alert-info mb-3" role="alert">
    <small>
        <i class="fa fa-info-circle"></i> 
        Policy issued <strong>{{daysSinceIssue}}</strong> day(s) ago.
        <span *ngIf="daysSinceIssue >= 1 && daysSinceIssue <= 15 && !aadharRequiredByAdmin">
            Aadhaar upload is optional for demographic changes within 15 days.
        </span>
        <span *ngIf="daysSinceIssue >= 1 && daysSinceIssue <= 15 && aadharRequiredByAdmin">
            Aadhaar upload is required as per admin request in previous rejection.
        </span>
        <span *ngIf="daysSinceIssue >= 16 && daysSinceIssue <= 30">
            Aadhaar upload is mandatory for demographic changes (16-30 days period).
        </span>
        <span *ngIf="daysSinceIssue > 30 && user.role == 'admin'">
            <strong>Admin Override:</strong> Endorsement allowed for admin users beyond 30 days.
        </span>
    </small>
</div>

<app-show-request-history [printCertificate]="certificate"></app-show-request-history>
<nav aria-label="breadcrumb">
    <ol class="breadcrumb" >
      <li class="breadcrumb-item active" aria-current="page">
        <i class="fa fa-car" style="margin-right: 10px; "></i>
        <p class="h5"> Vehicle Details</p></li>
    </ol>
  </nav>
<form [formGroup]="certficateForm" >
    <div class="form-row">
        <div class="form-group col">
            <label for="vehicleMake">Make</label>
            <select class="form-select" formControlName="vehicleMake" [ngClass]="{ 'is-invalid': (submitted && f.vehicleMake.errors) || hasFieldChanged('vehicleMake'), 'field-changed': hasFieldChanged('vehicleMake') }" >
                <option *ngFor="let vehicleMake of makeModel" [ngValue]="vehicleMake.make">
                  {{ vehicleMake.make }}
                </option>
              </select>
              <div *ngIf="submitted && f.vehicleMake.errors" class="invalid-feedback">
                <div *ngIf="f.vehicleMake.errors.required">Make needs to be selected</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('vehicleMake')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('vehicleMake')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('vehicleMake')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="model">Model</label>
            <select class="form-select" formControlName="model" [ngClass]="{ 'is-invalid':(submitted && f.model.errors) || hasFieldChanged('model'), 'field-changed': hasFieldChanged('model') }">
                <option *ngFor="let model of models" [ngValue]="model">
                  {{ model }}
                </option>
              </select>
            <div *ngIf="submitted && f.model.errors" class="invalid-feedback">
                <div *ngIf="f.model.errors.required">Model is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('model')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('model')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('model')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="type">Type</label>
            <select class="form-select" formControlName="type" [ngClass]="{ 'is-invalid': (submitted && f.type.errors) || hasFieldChanged('type'), 'field-changed': hasFieldChanged('type') }" >
                <option *ngFor="let type of types " [ngValue]="type">
                  {{ type }}
                </option>
              </select>
            <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
                <div *ngIf="f.type.errors.required">Type is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('type')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('type')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('type')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="variant">Variant</label>
            <input type="text" formControlName="variant" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.variant.errors) || hasFieldChanged('variant'), 'field-changed': hasFieldChanged('variant') }" />
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('variant')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('variant')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('variant')}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col">
            <label for="vehicleYear">Manufacturing Year</label>
            <select class="form-select" formControlName="vehicleYear" [ngClass]="{ 'is-invalid': (submitted && f.vehicleYear.errors) || hasFieldChanged('vehicleYear'), 'field-changed': hasFieldChanged('vehicleYear') }" >
                <option *ngFor="let vehicleYear of years " [ngValue]="vehicleYear">
                  {{ vehicleYear }}
                </option>
              </select>
            <div *ngIf="submitted && f.vehicleYear.errors" class="invalid-feedback">
                <div *ngIf="f.vehicleYear.errors.required">Manufacturing year is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('vehicleYear')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('vehicleYear')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('vehicleYear')}}</div>
                </div>
            </div>
        </div>
            <div class="form-group col">
            <label for="registrationNumber">Registration Number</label>
            <input type="text" formControlName="registrationNumber" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.registrationNumber.errors) || hasFieldChanged('registrationNumber'), 'field-changed': hasFieldChanged('registrationNumber') }" />
            <div *ngIf="submitted && f.registrationNumber.errors" class="invalid-feedback">
                <div *ngIf="f.registrationNumber.errors.required">Registration Number is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('registrationNumber')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('registrationNumber')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('registrationNumber')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="chasisNumber">Chasis Number</label>
            <input type="text" formControlName="chasisNumber" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.chasisNumber.errors) || hasFieldChanged('chasisNumber'), 'field-changed': hasFieldChanged('chasisNumber') }" />
            <div *ngIf="submitted && f.chasisNumber.errors" class="invalid-feedback">
                <div *ngIf="f.chasisNumber.errors.required">Chasis Number is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('chasisNumber')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('chasisNumber')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('chasisNumber')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="engineNumber">Engine Number</label>
            <input type="text" formControlName="engineNumber" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.engineNumber.errors) || hasFieldChanged('engineNumber'), 'field-changed': hasFieldChanged('engineNumber') }" />
            <div *ngIf="submitted && f.engineNumber.errors" class="invalid-feedback">
                <div *ngIf="f.engineNumber.errors.required">Engine Number is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('engineNumber')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('engineNumber')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('engineNumber')}}</div>
                </div>
            </div>
    </div>
</div>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb" >
          <li class="breadcrumb-item active" aria-current="page">
            <i class="fa fa-user" style="margin-right: 10px; "></i>
            <p class="h5" *ngIf = !isCorporate> Customer Details</p>
            <p class="h5" *ngIf = isCorporate> Corporate Details</p></li>
        </ol>
      </nav>
    <div class="form-row">
        <div class="form-group col">
            <label for="clientType">Client Type</label>
            <select class="form-select" formControlName="clientType" [ngClass]="{ 'is-invalid': (submitted && f.clientType.errors) || hasFieldChanged('clientType'), 'field-changed': hasFieldChanged('clientType') }" >
                <option *ngFor="let clientType of clientTypes" [ngValue]="clientType">
                  {{ clientType }}
                </option>
              </select>
              <div *ngIf="submitted && f.clientType.errors" class="invalid-feedback">
                <div *ngIf="f.clientType.errors.required">Client Type needs to be selected</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('clientType')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('clientType')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('clientType')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="firstName" *ngIf = !isCorporate>First Name</label>
            <label for="firstName" *ngIf = isCorporate>Organisation Name</label>
            <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.firstName.errors) || hasFieldChanged('firstName'), 'field-changed': hasFieldChanged('firstName') }" />
            <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                <div *ngIf="f.firstName.errors.required">Name is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('firstName')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('firstName')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('firstName')}}</div>
                </div>
            </div>
        </div>
        <!-- <div class="form-group col">
            <label for="middleName">Middle Name</label>
            <input type="text" formControlName="middleName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.middleName.errors }" />
            <div *ngIf="submitted && f.middleName.errors" class="invalid-feedback">
                <div *ngIf="f.middleName.errors.required">Middle Name is required</div>
            </div>
        </div> -->
        <div class="form-group col" *ngIf = !isCorporate>
            <label for="lastName">Last Name</label>
            <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.lastName.errors) || hasFieldChanged('lastName'), 'field-changed': hasFieldChanged('lastName') }" />
            <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                <div *ngIf="f.lastName.errors.required">Last Name is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('lastName')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('lastName')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('lastName')}}</div>
                </div>
            </div>
    </div>
</div>
    <div class="form-row">
        <div class="form-group col">
            <label for="email" *ngIf = !isCorporate>Email</label>
            <label for="email" *ngIf = isCorporate>Organisation Email</label>
            <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.email.errors) || hasFieldChanged('email'), 'field-changed': hasFieldChanged('email') }" />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">Email id is invalid</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('email')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('email')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('email')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="contactNumber">
                Contact Number
            </label>
            <input type="number" formControlName="contactNumber" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.contactNumber.errors) || hasFieldChanged('contactNumber'), 'field-changed': hasFieldChanged('contactNumber') }" />
            <div *ngIf="submitted && f.contactNumber.errors" class="invalid-feedback">
                <div *ngIf="f.contactNumber.errors.required">Contact Number is required</div>
                <div *ngIf="f.contactNumber.errors.minlength">Contact Number must be at least 6 characters</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('contactNumber')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('contactNumber')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('contactNumber')}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="form-row" *ngIf = !isCorporate>
        <div class="form-group col">
            <label for="gender">Gender</label>
            <select class="form-select" formControlName="gender" [ngClass]="{ 'is-invalid': (submitted && f.gender.errors) || hasFieldChanged('gender'), 'field-changed': hasFieldChanged('gender') }" >
                <option *ngFor="let gender of genders " [ngValue]="gender">
                  {{ gender }}
                </option>
              </select>
            <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                <div *ngIf="f.gender.errors.required">Gender is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('gender')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('gender')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('gender')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col" *ngIf="user.specialRoleAccess && user.specialRoleAccess.includes('canSeeAge')">
            <label for="ageOrDob">Age or Date of Birth</label>
            <div class="row">
                <div class="col">
                    <input type="radio" formControlName="ageOrDob" [value]="ageOrDobValue[1]"  [ngClass]="{ 'is-invalid': submitted && f.ageOrDob.errors }" />
                    &nbsp;&nbsp;<span>Age</span>
                </div>
                <div class="col">
                    <input type="radio" formControlName="ageOrDob"  [value]="ageOrDobValue[0]"  [ngClass]="{ 'is-invalid': submitted && f.ageOrDob.errors }" />
                    &nbsp;&nbsp;<span>Date of Birth</span>
                </div>
                <div *ngIf="f.ageOrDob.value != certificate.ageOrDob" class="invalid-feedback">
                    <div *ngIf="f.ageOrDob.value != certificate.ageOrDob">Old Value was {{certificate.ageOrDob}}</div>
                </div>
            </div>            
        </div>

        <div class="form-group col" *ngIf="f.ageOrDob.value == ageOrDobValue[1]">
            <label for="age">Age</label>
                <input type="number" formControlName="age" class="form-control" maxlength="3" [ngClass]="{ 'is-invalid': submitted && f.age.errors || hasFieldChanged('age'), 'field-changed': hasFieldChanged('age') }" />
                <div *ngIf="submitted && f.age.errors" class="invalid-feedback">
                    <div *ngIf="f.age.errors.required"> Age is required</div>
                    <div *ngIf="f.age.errors.max">Maximum age allowed is 80</div>
                    <div *ngIf="f.age.errors.min">Minimum age allowed is 15</div>
                </div>
                <!-- Enhanced Old/New Value Display -->
                <div *ngIf="hasFieldChanged('age')" class="value-comparison-container">
                    <div class="old-new-value-display">
                        <div class="value-label">Old Value:</div>
                        <div class="old-value">{{getOldValue('age')}}</div>
                        <div class="value-label">New Value:</div>
                        <div class="new-value">{{getNewValue('age')}}</div>
                    </div>
                </div>
        </div>
        <div class="form-group col" *ngIf="f.ageOrDob.value == ageOrDobValue[0]">
            <label for="dob">Date of Birth</label>
                <input class="form-control" formControlName="dob"  [minDate]="minDobDateModel" [maxDate]="maxDobDateModel" placeholder="DD/MM/YYYY" ngbDatepicker #d="ngbDatepicker" [ngClass]="{ 'is-invalid': submitted && f.dob.errors || hasDobChanged(), 'field-changed': hasDobChanged() }">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary fa fa-calendar" (click)="d.toggle()" type="button"></button>
                </div>
                <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                    <div >Date of birth is required and age should be between 15 to 80 years</div>
                </div>
                <!-- Enhanced Old/New Value Display for DOB -->
                <div *ngIf="hasDobChanged()" class="value-comparison-container">
                    <div class="old-new-value-display">
                        <div class="value-label">Old Value:</div>
                        <div class="old-value">{{getOldDobValue() || 'N/A'}}</div>
                        <div class="value-label">New Value:</div>
                        <div class="new-value">{{getNewDobValue() || 'N/A'}}</div>
                    </div>
                </div>
        </div>
    </div>
    
    <!-- Aadhar Card Upload Section -->
    <div class="form-row" *ngIf="aadharCardRequired || aadharCardUrl">
        <div class="form-group col-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item active" aria-current="page">
                        <i class="fa fa-id-card" style="margin-right: 10px;"></i>
                        <p class="h5">Aadhar Card Upload</p>
                    </li>
                </ol>
            </nav>
            
            <!-- Existing Aadhar Card Display -->
            <div *ngIf="aadharCardUrl && !aadharCardFile" class="mb-3">
                <div class="alert alert-info">
                    <strong>Aadhar Card Already Uploaded</strong>
                    <button type="button" class="btn btn-sm btn-primary ml-2" (click)="downloadAadharCard()">
                        <i class="fa fa-download"></i> Download Aadhar Card
                    </button>
                </div>
                <div class="aadhar-preview-container">
                    <img [src]="getAadharCardImageUrl(aadharCardUrl)" 
                         alt="Aadhar Card" 
                         class="aadhar-preview-image"
                         (error)="$event.target.style.display='none'">
                </div>
            </div>
            
            <!-- Aadhar Card Upload -->
            <div *ngIf="aadharCardRequired || !aadharCardUrl">
                <label for="aadharCardFile">Aadhar Card <span *ngIf="aadharCardRequired && user.role != 'admin'" class="text-danger">*</span></label>
                <div class="input-group">
                    <input type="file" 
                           id="aadharCardFile" 
                           class="form-control" 
                           accept="image/jpeg,image/jpg,image/png,application/pdf"
                           (change)="onAadharFileSelected($event)"
                           [disabled]="aadharCardUploading">
                    <button type="button" 
                            class="btn btn-outline-secondary" 
                            (click)="removeAadharCard()"
                            *ngIf="aadharCardFile"
                            [disabled]="aadharCardUploading">
                        <i class="fa fa-times"></i> Remove
                    </button>
                </div>
                
                <!-- File Preview -->
                <div *ngIf="aadharCardPreview" class="mt-2">
                    <img [src]="aadharCardPreview" alt="Aadhar Card Preview" class="aadhar-preview-image">
                </div>
                
                <!-- Upload Status -->
                <div *ngIf="aadharCardUploading" class="mt-2">
                    <div class="spinner-border spinner-border-sm" role="status">
                        <span class="sr-only">Uploading...</span>
                    </div>
                    <span class="ml-2">Uploading Aadhar card...</span>
                </div>
                
                <!-- Validation Message -->
                <div *ngIf="aadharCardRequired && user.role != 'admin' && !aadharCardUrl && !aadharCardFile && submitted" 
                     class="text-danger mt-1">
                    <small *ngIf="daysSinceIssue >= 16 && daysSinceIssue <= 30">
                        Aadhar card upload is mandatory for demographic changes after 15 days from issue date
                    </small>
                    <small *ngIf="daysSinceIssue >= 1 && daysSinceIssue <= 15 && aadharRequiredByAdmin">
                        Aadhar card upload is required as per admin request in previous rejection
                    </small>
                </div>
                
                <small class="form-text text-muted">
                    Accepted formats: JPG, JPEG, PNG, PDF. Maximum file size: 5MB
                </small>
            </div>
        </div>
    </div>
    
    <div class="form-row">
        <div class="form-group col">
            <label for="address" *ngIf = !isCorporate>Address</label>
            <label for="address" *ngIf = isCorporate>Organisation Address</label>
            <input type="text" formControlName="address" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.address.errors) || hasFieldChanged('address'), 'field-changed': hasFieldChanged('address') }" />
            <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                <div *ngIf="f.address.errors.required">Address is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('address')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('address')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('address')}}</div>
                </div>
            </div>
        </div>
            <div class="form-group col">
                <label for="state">State</label>
                <select class="form-select" formControlName="state" [ngClass]="{ 'is-invalid': (submitted && f.state.errors) || hasFieldChanged('state'), 'field-changed': hasFieldChanged('state') }" >
                    <option *ngFor="let state of stateCity" [ngValue]="state.state">
                      {{ state.state }}
                    </option>
                  </select>
                  <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                    <div *ngIf="f.state.errors.required">State needs to be selected</div>
                </div>
                <!-- Enhanced Old/New Value Display -->
                <div *ngIf="hasFieldChanged('state')" class="value-comparison-container">
                    <div class="old-new-value-display">
                        <div class="value-label">Old Value:</div>
                        <div class="old-value">{{getOldValue('state')}}</div>
                        <div class="value-label">New Value:</div>
                        <div class="new-value">{{getNewValue('state')}}</div>
                    </div>
                </div>
                </div>
            <div class="form-group col">
                <label for="city">City</label>
                <select class="form-select" formControlName="city" [ngClass]="{ 'is-invalid': (submitted && f.city.errors) || hasFieldChanged('city'), 'field-changed': hasFieldChanged('city') }">
                    <option *ngFor="let city of cities" [ngValue]="city">
                      {{ city }}
                    </option>
                  </select>
                <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                    <div *ngIf="f.city.errors.required">City is required</div>
                </div>
                <!-- Enhanced Old/New Value Display -->
                <div *ngIf="hasFieldChanged('city')" class="value-comparison-container">
                    <div class="old-new-value-display">
                        <div class="value-label">Old Value:</div>
                        <div class="old-value">{{getOldValue('city')}}</div>
                        <div class="value-label">New Value:</div>
                        <div class="new-value">{{getNewValue('city')}}</div>
                    </div>
                </div>
                </div>    
    </div>
    <nav aria-label="breadcrumb" *ngIf="certificate.nomineeName != 'NA'">
        <ol class="breadcrumb" >
          <li class="breadcrumb-item active" aria-current="page">
            <i class="fa fa-user" style="margin-right: 10px; "></i>
            <p class="h5" *ngIf = !isCorporate> Nominee Details</p>
            <p class="h5" *ngIf = isCorporate> Contact Person Details</p></li>
        </ol>
      </nav>
      <div class="form-row" *ngIf="certificate.nomineeName != 'NA'">
        <div class="form-group col">
            <label for="nomineeName" *ngIf = !isCorporate>Nominee Name</label>
            <label for="nomineeName" *ngIf = isCorporate>Name</label>
            <input type="text" formControlName="nomineeName" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.nomineeName.errors) || hasFieldChanged('nomineeName'), 'field-changed': hasFieldChanged('nomineeName') }" />
            <div *ngIf="submitted && f.nomineeName.errors" class="invalid-feedback">
                <div *ngIf="f.nomineeName.errors.required">Name is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('nomineeName')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('nomineeName')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('nomineeName')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col">
            <label for="nomineeGender" *ngIf = !isCorporate>Nominee Gender</label>
            <label for="nomineeGender" *ngIf = isCorporate>Gender</label>
            <select class="form-select" formControlName="nomineeGender" [ngClass]="{ 'is-invalid': (submitted && f.nomineeGender.errors) || hasFieldChanged('nomineeGender'), 'field-changed': hasFieldChanged('nomineeGender') }" >
                <option *ngFor="let nomineeGender of genders " [ngValue]="nomineeGender">
                  {{ nomineeGender }}
                </option>
              </select>
            <div *ngIf="submitted && f.nomineeGender.errors" class="invalid-feedback">
                <div *ngIf="f.nomineeGender.errors.required">Gender is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('nomineeGender')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('nomineeGender')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('nomineeGender')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col" *ngIf = !isCorporate>
            <label for="nomineeRelationship">Nominee Relationship</label>
            <select class="form-select" formControlName="nomineeRelationship" [ngClass]="{ 'is-invalid': (submitted && f.nomineeRelationship.errors) || hasFieldChanged('nomineeRelationship'), 'field-changed': hasFieldChanged('nomineeRelationship') }" >
                <option *ngFor="let nomineeRelationship of relationships " [ngValue]="nomineeRelationship">
                  {{ nomineeRelationship }}
                </option>
              </select>
            <div *ngIf="submitted && f.nomineeRelationship.errors" class="invalid-feedback">
                <div *ngIf="f.nomineeRelationship.errors.required">Nominee Relationship is required</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('nomineeRelationship')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('nomineeRelationship')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('nomineeRelationship')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col" >
            <label for="nomineeAge" *ngIf = !isCorporate>Nominee Age</label>
            <label for="nomineeAge" *ngIf = isCorporate> Age</label>
                <input type="number" formControlName="nomineeAge" class="form-control" [ngClass]="{ 'is-invalid': (submitted && f.nomineeAge.errors) || hasFieldChanged('nomineeAge'), 'field-changed': hasFieldChanged('nomineeAge') }" />
              <div *ngIf="submitted && f.nomineeAge.errors" class="invalid-feedback">
                <div *ngIf="f.nomineeAge.errors.required"> Age is required</div>
                <div *ngIf="f.nomineeAge.errors.max">Maximum age allowed is 100</div>
                <div *ngIf="f.nomineeAge.errors.min">Minimum age allowed is 1</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('nomineeAge')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('nomineeAge')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('nomineeAge')}}</div>
                </div>
            </div>
        </div>
        <div class="form-group col" *ngIf = isCorporate>
            <label for="employeeContactNumber">Contact Number</label>
            <input type="number" formControlName="employeeContactNumber" class="form-control" maxlength="10" [ngClass]="{ 'is-invalid': (submitted && f.employeeContactNumber.errors) || hasFieldChanged('employeeContactNumber'), 'field-changed': hasFieldChanged('employeeContactNumber') }" />
            <div *ngIf="submitted && f.employeeContactNumber.errors" class="invalid-feedback">
                <div *ngIf="f.employeeContactNumber.errors.required">Contact Number is required</div>
                <div *ngIf="f.employeeContactNumber.errors.minlength">Contact Number must be at least 6 characters</div>
            </div>
            <!-- Enhanced Old/New Value Display -->
            <div *ngIf="hasFieldChanged('employeeContactNumber')" class="value-comparison-container">
                <div class="old-new-value-display">
                    <div class="value-label">Old Value:</div>
                    <div class="old-value">{{getOldValue('employeeContactNumber')}}</div>
                    <div class="value-label">New Value:</div>
                    <div class="new-value">{{getNewValue('employeeContactNumber')}}</div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="certificateCreated">
        <nav aria-label="breadcrumb" >
            <ol class="breadcrumb" >
              <li class="breadcrumb-item active" aria-current="page" >
                <i class="fa fa-book" style="margin-right: 10px; "></i>
                <p class="h5"> Endorsement Details</p></li>
            </ol>
          </nav>
        <div class="form-row" *ngIf="certificateCreated">
    
        <div class="form-group col">
            <label for="endorsementReason">Endorsement Details</label>
            <input type="text" formControlName="endorsementReason" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.endorsementReason.errors }" disabled/>
        </div>
        <div class="form-group col">
            <label for="endorsementCount">Endorsement Count</label>
            <input type="text" formControlName="endorsementCount" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.endorsementCount.errors }" disabled/>
        </div>
    </div>
    </div>
    <nav aria-label="breadcrumb" *ngIf="certificate.nomineeName != 'NA'">
        <ol class="breadcrumb" >
          <li class="breadcrumb-item active" aria-current="page">
            <i class="fa fa-email" style="margin-right: 10px; "></i>
            <p class="h5" > Endorsement Communications</p></li>
        </ol>
      </nav>
      <div class="form-row">
        <div class="form-group col">
            <label for="notificationEmail">Dealer Email Id for Notification:</label>
            <input formControlName="notificationEmail" class="form-control" type="email"
            [ngClass]="{ 'is-invalid': f.notificationEmail.errors }">
          <div *ngIf="f.notificationEmail?.errors" class="invalid-feedback">
            <div *ngIf="f.notificationEmail?.errors.required">Email is required</div>
          </div>
        </div>
        <div class="form-group col">
        </div>
    </div>

    <div class="form-group">
        <button type="button" [disabled]="loading || endorsementBlocked" class="btn btn-primary" (click)="onEndorseClick()" *ngIf="endorseRequest && (certificateResponse.certificateStatus == 'Submitted' || certificateResponse.certificateStatus == 'Endorsement Rejected - Pending Resubmission')">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            Request Endorsement
        </button>
        <button type="button" [disabled]="loading || endorsementBlocked" class="btn btn-primary" (click)="onEndorseClick()" *ngIf="!(endorseRequest) ">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            Endorse
        </button>
        <a>&nbsp;&nbsp;</a>
        <button type="button" [disabled]="loading" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#rejectEndorsementModal" 
            *ngIf="!(endorseRequest) && (user.role == 'admin' || user.role == 'employee') && (certificate.certificateStatus == 'Endorsement Requested' || certificate.certificateStatus == 'Endorsement Rejected - Pending Resubmission')">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            Reject Endorsement
        </button>
        <a>&nbsp;&nbsp;</a>
        <button type="button" [disabled]="loading" class="btn btn-info" (click)="backToPrintCertificate()" >
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            Back
        </button><a>&nbsp;&nbsp;</a>
        <button type="button" *ngIf="certificateCreated" class="btn btn-success mr-1" (click)="onPdfClick()">
            Generate Certificate
        </button>
    </div>
</form>

<!-- Reject Endorsement Modal -->
<div class="modal fade" id="rejectEndorsementModal" tabindex="-1" aria-labelledby="rejectEndorsementModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="rejectEndorsementModalLabel">Reject Endorsement Request</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="rejectEndorsementForm">
          <div class="form-group mb-3">
            <label for="rejectComments">Rejection Comments (Required):</label>
            <textarea formControlName="rejectComments" class="form-control" rows="4"
              [ngClass]="{ 'is-invalid': rejectF.rejectComments.errors }"
              placeholder="Please provide detailed comments on why the endorsement request is being rejected..."></textarea>
            <div *ngIf="rejectF.rejectComments?.errors" class="invalid-feedback">
              <div *ngIf="rejectF.rejectComments?.errors.required">Rejection comments are required</div>
            </div>
          </div>
          
          <!-- Aadhaar Requirement Checkbox -->
          <div class="form-group mb-3">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="requireAadhaar" 
                formControlName="requireAadhaar"
                (change)="onRequireAadhaarChange()">
              <label class="form-check-label" for="requireAadhaar">
                Request Aadhaar Card - Require Aadhaar card proof to complete this endorsement
              </label>
            </div>
            <small class="form-text text-muted d-block mt-2">
              <strong>Aadhaar Requirement Policy:</strong>
              <ul style="margin-top: 8px; margin-bottom: 0;">
                <li><strong>1-15 days:</strong> Optional unless you check this box</li>
                <li><strong>16-30 days:</strong> Mandatory for demographic changes</li>
                <li><strong>&gt;30 days:</strong> Endorsement blocked - contact support</li>
              </ul>
            </small>
          </div>
          
          <div class="form-group mb-3">
            <label for="notificationEmail">Dealer Email Id for Notification:</label>
            <input formControlName="notificationEmail" class="form-control" type="email"
              [ngClass]="{ 'is-invalid': rejectF.notificationEmail.errors }"
              placeholder="Enter dealer email address">
            <div *ngIf="rejectF.notificationEmail?.errors" class="invalid-feedback">
              <div *ngIf="rejectF.notificationEmail?.errors.required">Email is required</div>
              <div *ngIf="rejectF.notificationEmail?.errors.email">Please enter a valid email address</div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="rejectEndorsementRequest()" [disabled]="loading || rejectEndorsementForm.invalid">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          <span *ngIf="!loading">Reject Endorsement</span>
        </button>
      </div>
    </div>
  </div>
</div>
